export const API_GET_ALL_BOXES = 'API_GET_ALL_BOXES';
export const API_GET_ALL_BOXES_SUCCESS = 'API_GET_ALL_BOXES_SUCCESS';
export const API_GET_ALL_BOXES_FAIL = 'API_GET_ALL_BOXES_FAIL';

export const API_ADMIN_GET_ALL_BOXES = 'API_ADMIN_GET_ALL_BOXES';
export const API_ADMIN_GET_ALL_BOXES_SUCCESS = 'API_ADMIN_GET_ALL_BOXES_SUCCESS';
export const API_ADMIN_GET_ALL_BOXES_FAIL = 'API_ADMIN_GET_ALL_BOXES_FAIL';

export const API_ADMIN_GET_BOX = 'API_ADMIN_GET_BOX';
export const API_ADMIN_GET_BOX_SUCCESS = 'API_ADMIN_GET_BOX_SUCCESS';
export const API_ADMIN_GET_BOX_FAIL = 'API_ADMIN_GET_BOX_FAIL';

export const API_ADMIN_PATCH_BOX = 'API_ADMIN_PATCH_BOX'
export const API_ADMIN_PATCH_BOX_SUCCESS = 'API_ADMIN_PATCH_BOX_SUCCESS'
export const API_ADMIN_PATCH_BOX_FAIL = 'API_ADMIN_PATCH_BOX_FAIL'

export const API_ADMIN_POST_BOX = 'API_ADMIN_POST_BOX'
export const API_ADMIN_POST_BOX_SUCCESS = 'API_ADMIN_POST_BOX_SUCCESS'
export const API_ADMIN_POST_BOX_FAIL = 'API_ADMIN_POST_BOX_FAIL'

export const API_ADMIN_DELETE_BOX = 'API_ADMIN_DELETE_BOX'
export const API_ADMIN_DELETE_BOX_SUCCESS = 'API_ADMIN_DELETE_BOX_SUCCESS'
export const API_ADMIN_DELETE_BOX_FAIL = 'API_ADMIN_DELETE_BOX_FAIL'

export const RESET_BOX = 'RESET_BOX';

export const SET_BOX = 'SET_BOX';
export const SET_BOX_SUCCESS = 'SET_BOX_SUCCESS';
export const SET_BOX_FAIL = 'SET_BOX_FAIL';

export const GET_BOX_USERS = 'GET_BOX_USERS';

export const ADMIN_INIT_NEW_BOX = 'ADMIN_INIT_NEW_BOX'

export const ADMIN_RESET_FOCUS_BOX = 'ADMIN_RESET_FOCUS_BOX'